import {
  PRICE_PLACEHOLDER,
  useHypotheticalReturnFee,
} from "@babackapp/return-widget-components/hooks/use-hypothetical-return-fee";
import { usePublicShop } from "@babackapp/return-widget-components/queries/use-public-shop";
import { useDiscountBonus } from "@babackapp/return-widget-components/hooks/use-discount-bonus";
import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { useParams } from "react-router-dom";
import { useWidgetParams } from "./use-widget-params";

export function useDiscountOption() {
  const t = useCustomText();
  const { orderId, shopId } = useWidgetParams();
  const { lineItemId = "" } = useParams<{ lineItemId: string }>();
  const { data: shop } = usePublicShop(shopId);
  const draft = useDraftReturn(orderId);

  const bonusCents = useDiscountBonus(orderId, shopId, lineItemId);
  const bonusText =
    bonusCents != null && bonusCents > 0
      ? t("discountOption.bonus", {
          amount: formatPrice(bonusCents, shop?.discount?.discount_bonus?.currency ?? "EUR"),
        })
      : null;

  const validity = shop?.discount?.validity ?? 0;
  const validityText =
    validity === -1
      ? t("discountOption.validityUnlimited")
      : validity > 0
        ? t("discountOption.validity", { months: String(validity) })
        : null;

  const draftLineItem = draft?.lineItems.find((li) => li.lineItemId === lineItemId);
  const feeState = useHypotheticalReturnFee("discount", {
    orderId,
    shopId,
    pendingLineItemId: lineItemId,
    pendingReasonId: draftLineItem?.reasonId ?? undefined,
  });

  const isFeeLoading = feeState.status === "loading";
  const feeText =
    isFeeLoading
      ? null
      : feeState.fee > 0
        ? `-${formatPrice(feeState.fee, "EUR")}`
        : null;

  const isDisabled =
    isFeeLoading ||
    (feeState.status === "ready" && feeState.isStale);

  return { bonusText, validityText, feeText, isFeeLoading, isDisabled };
}
